import React from 'react'
import * as IoIcons from 'react-icons/io';
 function EliminarUsuario() {
  return (
    <div>

<a ><button className="btn btn-danger " ><IoIcons.IoIosClose /></button></a>
    </div>
  )
}
export default EliminarUsuario
